import * as React from 'react';
const SvgPlayStroke = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 13 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.14 1.248a1 1 0 00-.14.51v12.49a1 1 0 001.51.86l10.538-6.245a1 1 0 000-1.72L1.51.896a1 1 0 00-1.37.35v.002zm9.437 6.755L2 12.493v-8.98l7.577 4.49z"
            fill="currentColor"
        />
    </svg>
);
export default SvgPlayStroke;
